import { useEffect } from 'react';
import '../styles/InfoSection.css';
import { useNavigate } from 'react-router-dom';
import LoginForm from './LoginForm.js'

function InfoSection() {
  const navigate = useNavigate();

  /* ── Redirect if already logged in ── */
  useEffect(() => {
    if (sessionStorage.getItem('isLoggedIn') === 'true') {
      navigate('/dashboard');
    }
  }, [navigate]);

  return (
    <>
      <div className="tag-line">QRmor: The Asset Protection Armor</div>
      <div className='reload-btn' onClick={() => window.location.reload()}>Reload Page</div>
      <div className="container_info">
        <div className="info-section">
          <video
            className="info-section__video"
            src="/assets/info_page.mp4"
            autoPlay
            loop
            muted
            playsInline
          />
        </div>
        <LoginForm />
      </div>
    </>
  );
}

export default InfoSection;